import { defineStore } from 'pinia';

export interface PermissionDenial {
    permission: string;
    message: string;
    timestamp: number;
}

export const usePermissionDenialStore = defineStore('permissionDenial', () => {
  const denials = ref<PermissionDenial[]>([]);
  const dismissed = ref(false);
  const forceShow = ref(false);

  const hasDenials = computed(() => forceShow.value || denials.value.length > 0);
  const uniqueDenials = computed(() => {
    const base = forceShow.value && denials.value.length === 0
      ? [{ permission: 'example.view', message: 'This is a test denial — the widget is working.', timestamp: Date.now() }]
      : denials.value;
    const seen = new Set<string>();
    return base.filter(d => {
      if (seen.has(d.permission)) return false;
      seen.add(d.permission);
      return true;
    });
  });

  function addDenials(newDenials: { permission: string; message: string }[]) {
    const now = Date.now();
    for (const d of newDenials) {
      if (!denials.value.some(existing => existing.permission === d.permission)) {
        denials.value.push({ ...d, timestamp: now });
        dismissed.value = false;
      }
    }
  }

  function dismiss() {
    dismissed.value = true;
  }

  function clear() {
    denials.value = [];
    dismissed.value = false;
  }

  function toggleForceShow() {
    forceShow.value = !forceShow.value;
    dismissed.value = false;
  }

  return { denials, dismissed, forceShow, hasDenials, uniqueDenials, addDenials, dismiss, clear, toggleForceShow };
});
